import { Link } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";

export const Container = styled.div`
  width: 900px;
  .spinner {
    left: 0;
    top: 0;
  }
  .meus-envios-cabecalho {
    ul {
      width: 100%;
      height: 40px;
      justify-content: space-evenly;
      font-size: 1.5rem;
      display: flex;
      li {
        list-style: none;
        margin-right: 40px;
      }
      margin-bottom: 20px;
    }
    margin-bottom: 100px;
  }
  .frete-list {
    margin-top: 50px;
  }

  .ffl-custom-checkbox {
    input[type="checkbox"] {
      width: 18px;
      height: 18px;
      border-radius: 5px;
      cursor: pointer;
    }
  }

  .w-100 {
    width: 100%;
  }

  @media (max-width: 1200px) {
    width: 400px;
    .meus-envios-cabecalho {
      ul {
        height: 60px;
      }
    }
  }

  @media (max-width: 700px) {
    width: 100%;
    .container-desktop {
      display: none;
    }
    .dots {
      margin-bottom: 2em;
      span {
        height: 10px;
        width: 10px;
        background-color: white;
        border-radius: 50%;
        display: inline-block;
        margin-right: 1em;
      }
    }
    .itens-mobile {
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
  }

  @media (min-width: 700px) {
    .container-mobile {
      display: none;
    }
  }
`;

export const SelectStatusFreteStyle = styled(Link)`
  cursor: pointer;
  text-decoration: none;
  color: ${(props) => (props.$selected ? "rgba(136,48,152,1)" : "#4a4a4a")};
  font-weight: ${(props) => (props.$selected ? "bold" : "")};
  border-bottom: ${(props) => (props.$selected ? "solid 3px rgba(136,48,152,1)" : "")};

  @media (max-width: 700px) {
  }
`;

export const FreteListSearchForm = styled.div`
  background-color: #fff;
  padding: 25px;

  .formulario-titulo {
    h2 {
      font-size: 1.8rem;
      font-weight: bold;
    }
    display: flex;
    justify-content: flex-start;
    margin-bottom: 35px;
  }

  .formulario-busca-inputs {
    display: flex;
    justify-content: space-between;

    .formulario-busca-input-area {
      text-align: left;
      width: 180px;
      label {
        white-space: nowrap;
      }
    }
    .formulario-busca-input-area.quantidade-fretes {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      select {
        width: 100%;
      }
    }

    // Novos filtros
    .input,
    .select select,
    .textarea {
      color: #6c757d;
    }

    .input:focus,
    .select select:focus,
    .textarea:focus {
      border-color: rgb(148, 105, 241) !important;
      box-shadow: 0 0 0 0.125em rgba(136, 48, 152, 0.25) !important;
      outline: none !important;
    }

    .calendar .input {
      padding-left: 1rem;
    }

    .multiselect-custom {
      width: 100%;
      padding: 0.5rem 0.5rem !important;
      .multiselect__select {
        width: 100%;
      }
    }

    .p-multiselect,
    .p-multiselect-panel,
    .p-multiselect-item,
    .p-multiselect-filter-container input {
      font-size: 1em;
      font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell,
        "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
  }
  .filtros-paginas {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .dots-filtros {
    display: none;
  }
  .buscar-button,
  .loadmore-button {
    background-color: rgba(136, 48, 152, 1);
    color: #fff;
    padding: 0px 60px;
    font-weight: bold;
  }
  li {
    list-style: none;
    margin-right: 40px;
  }

  @media (max-width: 1200px) {
    .formulario-busca-inputs {
      flex-direction: column;
      .formulario-busca-input-area {
        margin-bottom: 25px;
      }
      .quantidade-fretes {
        width: 90%;
      }
    }
  }

  @media (max-width: 700px) {
    .filtros-paginas {
      flex-direction: row;
      overflow-x: auto;
      scroll-snap-type: x mandatory;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      & > div {
        flex: 0 0 100%;
        flex-direction: column;
        scroll-snap-align: start;
      }
    }

    .formulario-busca-inputs .formulario-busca-input-area {
      width: 100%;
      margin-bottom: 0;

      label {
        white-space: normal;
      }
    }

    .dots-filtros {
      display: flex;
      justify-content: center;
      gap: 1em;

      button {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        border: none;
        padding: 0;
        margin: 0;
        cursor: pointer;
      }
    }
  }
`;

export const MeusEnviosFreteStyle = styled.li`
  border-top: solid 1.5px #ddd;
  margin: 30px 0;
  header {
    margin: 20px 0;
    font-size: 1.4rem;
  }
  .header-label {
    margin-right: 10px;
  }
  .meus-envios-frete-cabecalho-aguardando,
  .meus-envios-frete-cabecalho-postado {
    display: flex;
    justify-content: space-between;
    div {
      display: flex;
    }
    .show-frete-desktop {
      display: block;
      width: 20px;
      cursor: pointer;
    }
    .show-frete-mobile {
      display: none;
    }
    .delete-frete {
      cursor: pointer;
    }
    .icon-delete {
      color: #f14668;
      font-size: 1.8rem;
    }
    .icon-warning {
      color: red;
      font-size: 1.8rem;
    }
    .icon-danger {
      color: #ffe08a;
      font-size: 1.8rem;
    }
    .expiracao-postado {
      margin-right: 10px;
    }
  }

  strong {
    margin-right: 10px;
  }
  .meus-envios-frete-cabecalho-gerado {
    display: flex;
    margin-top: 20px;
    align-items: center;
    cursor: pointer;
    ion-icon {
      margin-right: 5px;
    }
    span {
      margin-right: 20px;
    }
  }
  .rastreio-frete-container-area {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    width: 800px;
  }

  .meus-envios-frete-container-area,
  .meus-envios-frete-container-area-pessoa,
  .volumes {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    width: 400px;
  }
  .meus-envios-frete-section {
    display: flex;
    width: 100%;
    margin: 10px 0;
  }
  .line-label {
    margin-right: 10px;
    white-space: nowrap;
  }
  .container-area-line {
    display: flex;
    justify-content: flex-start;
    font-size: 1.3rem;
  }
  .pessoa-titulo {
    text-align: left;
    h4 {
      font-size: 1.7rem;
      font-weight: bold;
    }

    margin: 20px 0;
  }
  .declaracao-conteudo-titulo {
    text-align: left;
    h4 {
      font-size: 1.7rem;
      font-weight: bold;
    }

    margin: 20px 0;
  }
  .nota-fiscal-titulo {
    text-align: left;
    h4 {
      font-size: 1.7rem;
      font-weight: bold;
    }

    margin: 20px 0;
  }
  .container-volumes-etiqueta {
    display: flex;
    align-items: flex-start;
  }
  .container-declaracao-conteudo {
    margin: 20px 0;
  }
  .container-nota-fiscal {
    margin: 20px 0;
  }
  .etiqueta {
    width: 400px;
    display: flex;
    justify-content: flex-start;

    .declaracao {
      margin-left: 10px;
    }
  }

  @media (max-width: 1200px) {
    .meus-envios-frete-cabecalho-aguardando,
    .meus-envios-frete-cabecalho-postado,
    .meus-envios-frete-cabecalho-gerado,
    .container-volumes-etiqueta {
      flex-direction: column;
      .show-frete-desktop {
        display: none;
      }
      .show-frete-mobile {
        display: block;
        width: 20px;
        cursor: pointer;
      }
    }
    .meus-envios-frete-container-area,
    .meus-envios-frete-container-area-pessoa,
    .volumes {
      width: 100%;
    }

    .meus-envios-frete-section {
      flex-direction: column;
    }
    .container-area-line {
    }

    .etiqueta {
      width: 100%;
      margin-top: 20px;

      flex-direction: column;

      .declaracao {
        margin-left: 0;
        margin-top: 5px;
      }
    }
  }

  @media (max-width: 770px) {
    .etiqueta {
      flex-direction: column;

      .declaracao {
        font-size: 0.7em;
      }
    }
  }

  .volumes {
    text-align: left;
    p {
      font-size: 1.3rem;
    }
  }
     margin-left: 0;
                margin-top: 5px;
            }
        }

    }

    @media (max-width: 770px) {
        .etiqueta{
            flex-direction: column;

            .declaracao{
                font-size: 0.7em;
            }
        }
	}

    .volumes{
        text-align: left;
        p{
            font-size: 1.3rem;
        }
    }

`;

// Estilização personalizada para o painel de filtros do MultiSelect
export const GlobalFilterStyle = createGlobalStyle`
  .custom-filter-panel {
    background: #ffffff !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
    border: 1px solid #e5e7eb !important;
  }

  // Estilização do cabeçalho da caixa de filtros
  .custom-filter-panel .p-multiselect-header {
    display: flex !important;
    flex-direction: column !important; 
    align-items: flex-start !important; /* <-- FORÇA TUDO PARA A ESQUERDA */
    padding: 15px 15px 5px 15px !important;
    background: transparent !important;
    border-bottom: 1px solid #e5e7eb !important;
  }

  // Esconde o "X" de fechar
  .custom-filter-panel .p-multiselect-close {
    display: none !important;
  }

  // Estilização do container de busca
  .custom-filter-panel .p-multiselect-filter-container {
    width: 100% !important;
    order: -1 !important; /* Joga a busca para o topo */
    margin-bottom: 15px !important;
    position: relative !important;
  }

  // Estilização do campo de busca
  .custom-filter-panel .p-multiselect-filter-container .p-inputtext {
    width: 100% !important;
    height: 40px !important;
    padding: 5px 10px 5px 35px !important;
    border-radius: 6px !important;
    border: 1px solid #d1d5db !important;
    font-family: inherit !important;
    color: #111827 !important;
    font-weight: 600 !important;
    font-size: 1.1rem !important;
  }

  // Estilização do ícone de lupa dentro do campo de busca
  .custom-filter-panel .p-multiselect-filter-container .p-multiselect-filter-icon {
    position: absolute !important;
    left: 12px !important;
    right: auto !important; 
    top: 50% !important;
    transform: translateY(-50%) !important;
    color: #6b7280 !important;
  }

  // Personalização do checkbox "Selecionar tudo"
  .custom-filter-panel .p-multiselect-select-all {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important; 
    width: 100% !important;
    padding: 5px 0 !important;
    margin-bottom: 5px !important;
  }

  // Personalização do texto "Selecionar tudo"
  .custom-filter-panel .p-multiselect-select-all::after {
    content: "Selecionar tudo";
    margin-left: 10px;
    font-family: inherit;
    color: #111827 !important;
    font-weight: 600 !important;
    font-size: 1.1rem !important;
  }

  // Distanciamento dos itens da lista
  .custom-filter-panel .p-multiselect-item {
    padding: 8px 15px !important;
    border-radius: 4px !important;
    margin: 2px 10px !important;
    color: #282828 !important;
    font-weight: 500 !important;
    font-size: 0.95rem !important;
  }
  
  // Cor quando selecionado
  .custom-filter-panel .p-multiselect-item.p-highlight {
    background-color: rgba(136,48,152,0.05) !important;
    color: rgba(136,48,152,1) !important;
    font-weight: 600 !important;
  }
`;
